export const MAIN_CLASS_NAME = 'elma365-version-merge-changes';
